module.exports = __webpack_public_path__ + "static/img/index-banner1.cfcaafa7.png";